import styled from 'styled-components'

const BaseFitmentText = styled.p`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-style: normal;
  line-height: 165%;
  display: inline-block;
`
export const StyledFitmentWrapper = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1.5px solid ${props => props.borderColor};
  background: ${props => props.bgColor};
  position: relative;
  min-height: 48px;
  align-items: center;
`

export const StyledIconContainer = styled.div`
  width: 32px;
  height: 32px;
  margin-right: 4px;
  margin-top: -2px;
  display: flex;
  justify-content: center;
  align-self: center;
  align-items: center;
`

export const StyledFitmentLabel = styled.p`
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 165%;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: ${props => (props.isRecommendation ? '0' : '8px')};
`
export const StyledGuaranteedFit = styled(BaseFitmentText)`
  color: #496E30;
  font-weight: 600;
  margin: 0;
`
export const StyledDoesNotFit = styled(BaseFitmentText)`
  color: #CC3333;
  font-weight: 600;
  margin: 0;
`
export const StyledUniversalFit = styled(BaseFitmentText)`
  color: #5E5E65;
  font-weight: 600;
  margin: 0;
`
export const StyledFitmentVehicle = styled(BaseFitmentText)`
  color: #282832;
  font-weight: 500;
  margin: 0;
`
